import { zip } from 'utils/form';
import Client from 'containers/app/client';

export const STAGE_STATUS_FINISH = 'finish';
export const STAGE_STATUS_EMPTY = 'wait';
export const STAGE_STATUS_ACTIVE = 'process';

export const isStageEmpty = (values, fields) => {
  if (!values) return true;
  return !Object.keys(fields)
    .map((key) => Object.prototype.hasOwnProperty.call(values, key))
    .every(Boolean);
};

export const isStageComplete = async (values, schema) => {
  try {
    const isValid = await schema.isValid(values);
    return isValid;
  } catch (e) {
    return false;
  }
};

export const setStagesPath = (arr) => {
  return arr.map((item, i) => {
    return {
      ...item,
      path: `stage-${(i + 1).toString().padStart(2, '0')}`,
    };
  });
};

export const setStageStatus = async (stage) => {
  const { schema, fields } = stage;
  if (stage.getValues == null) {
    throw new Error(`Stage ${stage.title} is missing a getValues function`);
  }
  const values = await stage.getValues();
  const zipValues = zip(fields, values);
  const status = (await isStageComplete(zipValues, schema))
    ? STAGE_STATUS_FINISH
    : STAGE_STATUS_EMPTY;

  return {
    ...stage,
    disabled: false,
    status,
  };
};

export const setStagesStatus = async (arr) => {
  return Promise.all(arr.map(setStageStatus));
};

export const isProfileCompleteWithStatus = (arr) => {
  const res = arr.filter(({ status }) => status === STAGE_STATUS_FINISH);
  return res.length;
};

export const isProfileComplete = async (arr, values) => {
  const stages = await setStagesStatus(arr, values);
  return isProfileCompleteWithStatus(stages);
};

export const getProfileValues = async () => {
  const ref = await Client.dbProfile().get();
  return ref.data();
};

export const getOrganizationValues = async () => {
  const userRef = await Client.dbProfile().get();
  const { organization } = userRef.data();
  if (organization == null) return null;
  const orgRef = await Client.dbOrganization(organization).get();
  return orgRef.data();
};
